'use client';

import React from 'react';
import { Package } from 'lucide-react';

interface EquipmentSelectorProps {
  selectedEquipment: string;
  handleEquipmentChange: (equipmentType: string) => void;
}

const trailerTypes = [
  'Water Trailer',
  'Enclosed Trailer',
  'Plant Trailer',
  'Box Trailer',
  'Jet Trailer',
  'Car Trailer'
];

const EquipmentSelector: React.FC<EquipmentSelectorProps> = ({
  selectedEquipment,
  handleEquipmentChange
}) => {
  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2 mb-4">
        <Package className="w-5 h-5 text-gray-400" />
        <label className="text-gray-700 font-medium">What equipment do you need?</label>
      </div>
      
      <select
        value={selectedEquipment}
        onChange={(e) => handleEquipmentChange(e.target.value)}
        className="w-full p-3 rounded-lg border-2 border-gray-300 focus:border-green-500 focus:ring-green-500 focus:ring-2 bg-white text-gray-900 font-medium"
      >
        <option value="">Select equipment type...</option>
        {trailerTypes.map((trailer) => (
          <option key={trailer} value={trailer}>
            {trailer}
          </option>
        ))}
      </select>
    </div>
  );
};

export default EquipmentSelector;